/**
 * Video export errors and their user-facing copy. Every failure the export
 * dialog shows goes through `describeExportError`, so nothing surfaces as a
 * bare stack-trace message.
 */

/** Thrown when no backend at all can encode here. `message` is user-facing. */
export class VideoExportUnsupportedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'VideoExportUnsupportedError';
  }
}

export function abortError(): DOMException {
  return new DOMException('Export cancelled', 'AbortError');
}

export function isAbortError(err: unknown): boolean {
  return err instanceof DOMException && err.name === 'AbortError';
}

export function describeExportError(err: unknown): string {
  if (isAbortError(err)) return 'Export cancelled.';
  if (err instanceof DOMException && err.name === 'SecurityError') {
    return (
      'An image in your design couldn’t be read by the exporter (it was blocked by the ' +
      'image host). Re-upload that image, then export again.'
    );
  }
  if (err instanceof Error && err.message) return err.message;
  return 'The export failed. Please try again.';
}
